import { render, staticRenderFns } from "./notification-detail-sent-phone-note.vue?vue&type=template&id=208d3da6&"
import script from "./notification-detail-sent-phone-note.vue?vue&type=script&lang=js&"
export * from "./notification-detail-sent-phone-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports